"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const classnames_1 = __importDefault(require("classnames"));
const react_1 = require("react");
const react_select_1 = __importStar(require("react-select"));
const react_window_1 = require("react-window");
const components_1 = require("components");
const config_1 = require("config");
const filteroptions_1 = require("./filteroptions");
const MenuList = ({ options, children, maxHeight, getValue, }) => {
    const [value] = getValue();
    const height = options.length * config_1.MENU_HEIGHT;
    const isSmallSelect = height < maxHeight;
    const initialOffset = options.indexOf(value) >= 0 && !isSmallSelect
        ? options.indexOf(value) * config_1.MENU_HEIGHT
        : 0;
    return ((0, jsx_runtime_1.jsx)(react_window_1.FixedSizeList, { height: height < maxHeight ? height : maxHeight, itemCount: react_1.Children.count(children), itemSize: config_1.MENU_HEIGHT, initialScrollOffset: initialOffset, width: "100%", children: ({ index, style }) => {
            return ((0, jsx_runtime_1.jsxs)("div", { style: style, children: [children && children[index], ' '] }));
        } }));
};
const Select = ({ allOption = {
    label: 'Select all',
    value: '*',
}, allowSelectAll, className, initialValue, input, label, meta, options, required, placeholder, maxDisplay = config_1.MAX_DISPLAYED_SELECT_ITEMS, ...rest }) => {
    const [defaultValue, setDefaultValue] = (0, react_1.useState)(initialValue);
    const [selectInput, setSelectInput] = (0, react_1.useState)('');
    const optionsData = allowSelectAll ? [allOption, ...options] : options;
    const MultiValue = ({ index, getValue, ...rest }) => {
        const overflow = getValue()
            .slice(maxDisplay)
            .map((item) => item.label);
        if (index < maxDisplay) {
            return ((0, jsx_runtime_1.jsx)(react_select_1.components.MultiValue, { ...rest, index: index, getValue: getValue }));
        }
        else if (index === maxDisplay) {
            return (0, jsx_runtime_1.jsx)(MoreSelectedBadge, { items: overflow });
        }
        return null;
    };
    return ((0, jsx_runtime_1.jsxs)("div", { className: (0, classnames_1.default)('select-container', className), children: [(0, jsx_runtime_1.jsxs)(components_1.Label, { size: "small", htmlFor: input?.name, children: [label, required && ((0, jsx_runtime_1.jsx)("span", { className: "required-indicator", "aria-hidden": "true", children: "*" }))] }), (0, jsx_runtime_1.jsxs)("div", { className: "select-input", children: [(0, jsx_runtime_1.jsx)(react_select_1.default, { ...rest, classNamePrefix: "custom-select", onBlur: (event) => event.preventDefault(), filterOption: allowSelectAll
                            ? filteroptions_1.filterOptions
                            : (0, react_select_1.createFilter)({ ignoreAccents: false }), components: { Option, MenuList, MultiValue }, options: optionsData, value: defaultValue ? defaultValue : input?.value, defaultValue: defaultValue, placeholder: placeholder, inputValue: selectInput, onChange: (selected) => {
                            if (selected !== null &&
                                selected.length > 0 &&
                                selected[selected.length - 1].value === allOption?.value) {
                                return input.onChange(options);
                            }
                            setSelectInput('');
                            setDefaultValue(undefined);
                            return input.onChange(selected);
                        }, onInputChange: (newValue, action) => {
                            // many selectable
                            if (allowSelectAll) {
                                // prevents resetting search
                                if (action.action === 'input-change') {
                                    setSelectInput(newValue);
                                }
                            }
                            else {
                                if (action.action === 'input-change' ||
                                    action.action === 'set-value') {
                                    setSelectInput(newValue);
                                }
                            }
                        } }), meta && meta.touched && meta.error && ((0, jsx_runtime_1.jsx)("span", { className: "error-message", children: meta.error }))] })] }));
};
const Option = (props) => {
    return ((0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(react_select_1.components.Option, { ...props, className: "custom-option", children: (0, jsx_runtime_1.jsx)("label", { children: props.label }) }) }));
};
const MoreSelectedBadge = ({ items }) => {
    const length = items.length;
    const label = `+ ${length} item${length !== 1 ? 's' : ''} selected`;
    return (0, jsx_runtime_1.jsx)("div", { className: "custom-select__truncation-label", children: label });
};
exports.default = Select;
